// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"5a6b7070","1139":"54f3f9be","3939":"0f84c088","4490":"cf3ffe2b","8645":"cf3ffe2b","9344":"61b7fa6c"}[chunkId] + ".chunk.css";
};